/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueuePositionModel } from '../../models/queue-position-model';

export interface QueuePositionGet$Params {
  lobbyId?: string;
}

export function queuePositionGet(http: HttpClient, rootUrl: string, params?: QueuePositionGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<QueuePositionModel>> {
  const rb = new RequestBuilder(rootUrl, queuePositionGet.PATH, 'get');
  if (params) {
    rb.query('lobbyId', params.lobbyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<QueuePositionModel>;
    })
  );
}

queuePositionGet.PATH = '/Queue/Position';
